<script setup lang="ts">
export interface ToggleOption {
  value: string;
  label: string;
  subtitle?: string;
}

const props = defineProps<{
  options: ToggleOption[];
  modelValue: string;
  name: string;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

function handleChange(value: string) {
  emit('update:modelValue', value);
}
</script>

<template>
  <div class="toggle-button-group" role="radiogroup">
    <label
      v-for="option in props.options"
      :key="option.value"
      class="toggle-button-group__button"
      :class="{ 'toggle-button-group__button--active': props.modelValue === option.value }"
    >
      <input
        type="radio"
        :name="props.name"
        :value="option.value"
        :checked="props.modelValue === option.value"
        class="toggle-button-group__input"
        @change="handleChange(option.value)"
      />
      <span class="toggle-button-group__radio" aria-hidden="true"></span>
      <span class="toggle-button-group__label">{{ option.label }}</span>
    </label>
  </div>
</template>
